import { Link } from 'react-router-dom';
import { fmtDate, fmtDateTime } from '@em/shared';
import { usePeriods, useSettings } from '../../api';
import { Badge, Card, EmptyState, PageHeader, PeriodBadge, QueryState } from '../../components/ui';

export function PeriodsPage() {
  const q = usePeriods();
  const settings = useSettings();
  const tz = settings.data?.defaultTimezone ?? 'Australia/Sydney';

  return (
    <>
      <PageHeader title="Pay periods" subtitle={settings.data ? `${settings.data.payPeriodType === 'weekly' ? 'Weekly' : 'Fortnightly'} periods. Approve every timesheet before the deadline, then payroll locks and exports.` : undefined} />
      <Card tight>
        <QueryState q={q} loadingLabel="Loading pay periods">
          {(periods) =>
            periods.length === 0 ? (
              <EmptyState title="No pay periods yet" />
            ) : (
              <div className="table-wrap">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Period</th>
                      <th>Status</th>
                      <th>Approval deadline</th>
                      <th className="num">Timesheets</th>
                      <th className="num">Needs attention</th>
                      <th className="num">Ready</th>
                      <th className="num">Approved</th>
                      <th>Locked by</th>
                    </tr>
                  </thead>
                  <tbody>
                    {periods.map((p) => (
                      <tr key={p.id}>
                        <td className="strong nowrap">
                          <Link to={`/periods/${p.id}`}>
                            {fmtDate(p.startDate)} – {fmtDate(p.endDate)}
                          </Link>{' '}
                          {p.isCurrent && <Badge tone="accent">Current</Badge>}
                        </td>
                        <td>
                          <PeriodBadge status={p.status} />
                        </td>
                        <td className="nowrap">{fmtDateTime(p.approvalDeadline, tz)}</td>
                        <td className="num">{p.counts.total}</td>
                        <td className={`num ${p.counts.needs_attention ? 'red strong' : ''}`}>{p.counts.needs_attention}</td>
                        <td className="num">{p.counts.ready}</td>
                        <td className="num">{p.counts.approved + p.counts.locked + p.counts.exported}</td>
                        <td>
                          {p.lockedByName ? (
                            <>
                              {p.lockedByName}
                              {p.lockedAt && <div className="small muted">{fmtDateTime(p.lockedAt, tz)}</div>}
                            </>
                          ) : (
                            <span className="muted">–</span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )
          }
        </QueryState>
      </Card>
    </>
  );
}
